import { call, put, takeLatest } from 'redux-saga/effects';
import { displayNotification } from '../../actions/notification';
import * as Types from '../../actions/types';
import * as User from '../../../api/user';
import * as Notifications from '../../../config/notifications';
import { userInfo } from '../../actions/user';
import { Messages } from '../../../config';
import { errorCatch } from '../helper.saga';
import { store } from '../../store';
import { showGlobalNotification } from '../../actions/globalNotification';
import { NOTIFICATION_SUCCESS } from '../../actions/types';

function* userUpdateProfileSaga(action) {
  let response;
  let notificationId = action.payload.first_name ? Notifications.NOTIFICATION_EDIT_USER_DETAILS : Notifications.NOTIFICATION_CHANGE_PASSWORD;

  if (action.payload.passkey_auth) {
    notificationId = Notifications.NOTIFICATIONS_CHANGE_ACCOUNT_SECURITY;
  }

  let messageSuccess = Messages.USER_CHANGED_SUCCESS;

  try {
    response = yield call(User.updateUserProfile, action.payload);

    if (response?.data?.data?.id) {
      if (response?.data?.data?.passkey_token) {
        let response_passkey_token = response.data.data.passkey_token;
        let responsePasskey = yield call(User.registerPasskey, { passkey_token: response_passkey_token });

        if (! responsePasskey) {
          return;
        }
        
        response = yield call(User.updateUserProfile, { passkey_auth_register_token: responsePasskey.token});
      }

      const {id, first_name, last_name, email, passkey_auth} = response.data.data;

      yield put(userInfo(id, first_name, last_name, email, [], [], passkey_auth));

      if (action.payload.old_password) {
        messageSuccess = Messages.PASSWORD_CHANGED_SUCCESS
      }

      store.dispatch(showGlobalNotification(NOTIFICATION_SUCCESS, messageSuccess));
    }
  } catch (e) {
    yield errorCatch(e, {
      400: function* () {
        yield put(displayNotification(Types.NOTIFICATION_ERROR, e.response.data.message, notificationId));
      }
    });
  }
}

export default function* userSaga() {
  yield takeLatest(Types.UPDATE_PROFILE, userUpdateProfileSaga);
}
